import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import LordIcon from '../LordIcon';
import LORDICONS from '../../lordicons';
import API_BASE from '../../config';

const adminNav = (t: (k: string) => string) => [
  { name: t('admin.nav.dashboard'), icon: LORDICONS.dashboard, path: '/admin' },
  { name: t('admin.nav.users'), icon: LORDICONS.users, path: '/admin/users' },
  { name: t('admin.nav.businesses'), icon: LORDICONS.building, path: '/admin/businesses' },
  { name: t('admin.nav.credits'), icon: LORDICONS.wallet, path: '/admin/credits' },
  { name: t('admin.nav.contacts'), icon: LORDICONS.email, path: '/admin/contacts' },
  { name: t('admin.nav.activity'), icon: LORDICONS.history, path: '/admin/activity' },
  { name: t('admin.nav.contracts'), icon: LORDICONS.document, path: '/admin/contracts' },
  { name: t('admin.nav.jobs'), icon: LORDICONS.briefcase, path: '/admin/jobs' },
  { name: t('admin.nav.blog'), icon: LORDICONS.document, path: '/admin/blog' },
  { name: t('admin.nav.announcements'), icon: LORDICONS.bell, path: '/admin/announcements' },
];

const AdminLayout: React.FC = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    await fetch(`${API_BASE}/api/logout`, { method: 'POST', credentials: 'include' });
    localStorage.removeItem('user');
    navigate('/login');
  };

  return (
    <div className="h-screen bg-[#F7F8FA] flex overflow-hidden">
      <aside className="fixed top-0 left-0 h-full z-30 w-auto">
        <div className="h-[95vh] w-64 bg-white border border-[#E8EDF5] rounded-card shadow-sm m-4 flex flex-col">
          <div className="px-6 py-8">
            <img src="/images/ompli-logo-blue.png" alt="Ompli" className="h-7 w-auto mb-2" />
            <p className="text-xs font-semibold uppercase tracking-wide text-[#0065F4]">
              {t('admin.badge')}
            </p>
          </div>
          <nav className="flex-1 px-4 space-y-1 overflow-y-auto">
            {adminNav(t).map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/admin'}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-50 text-[#0065F4]'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-[#0065F4]'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <LordIcon
                      src={item.icon}
                      trigger={isActive ? 'loop-on-hover' : 'hover'}
                      size={20}
                      color={isActive ? '#0065F4' : '#6B7280'}
                      hoverColor="#0065F4"
                      target="a"
                    />
                    <span>{item.name}</span>
                  </>
                )}
              </NavLink>
            ))}
          </nav>
          <div className="p-4 border-t border-gray-100 space-y-1">
            <button
              type="button"
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-[#0065F4]"
            >
              <LordIcon
                src={LORDICONS.logout}
                trigger="hover"
                size={20}
                color="#6B7280"
                hoverColor="#0065F4"
                target="button"
              />
              <span>{t('logout')}</span>
            </button>
          </div>
        </div>
      </aside>
      <div className="flex-1 ml-[272px] min-w-0 h-full overflow-hidden">
        <main className="p-6 h-full min-w-0 overflow-y-auto overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
